import React from 'react';

import type { InputApi } from './hooks';
import type { InputProps } from './InputProps';
import DefaultInput, { InputContainer } from './variants/Default';
import TCKNInput, { TCKNProps } from './variants/TCKN';

export * from './hooks';

// Daha anlaşılır ve React 19 uyumlu tip tanımı + Antd Input instance desteği
export interface SeturInputProps extends InputProps, TCKNProps {
  variant?: 'default' | 'tckn';
  onChange?: (value: string) => void;
  // Antd Input referansı ( { input: HTMLInputElement } ) veya direkt native input
  inputRef?: React.RefObject<HTMLInputElement | { input: HTMLInputElement }>;
  getInputAPI?: (
    api: InputApi,
    nativeInputRef?: React.RefObject<HTMLInputElement>
  ) => void;
  alwayseditable?: boolean;
}

function Input(props: SeturInputProps) {
  const { variant, alwayseditable, ...rest } = props;
  if (variant === 'tckn') {
    return <TCKNInput {...rest} alwayseditable={alwayseditable ?? false} />;
  }
  return <DefaultInput {...rest} />;
}

export default Input;
export { InputContainer };
